export default {"src":"/_next/static/media/icon_last.e51c09d3.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};